import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../api/baseurl";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Spinner.css";

const UploadEmployeesCsvFile = ({ isOpen, onRequestClose, companyId, companycode }) => {
  const [employees, setEmployees] = useState({
    file: null,
    companyId: companyId,
    sendNotification: false, // To handle notification sending
  });

  const [loading, setLoading] = useState(false);
  const [csvFile, setCsvFile] = useState(null);
  const [sendNotification, setSendNotification] = useState(false); // State for notification checkbox

  const url = "/api/employeedetails/upload";
  const navigate = useNavigate();

  useEffect(() => {
    setEmployees((prev) => ({
      ...prev,
      companyId: companyId,
    }));
  }, [companyId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;

    const formData = new FormData();
    formData.append("file", csvFile);
    formData.append("companyId", employees.companyId);
    formData.append("sendNotification", sendNotification);

    try {
      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("CSV file uploaded successfully");
      setLoading(false);
      onRequestClose();
      setEmployees("");
      setCsvFile(null);
      setSendNotification(false); // Reset notification checkbox
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const rhandle = (e) => {
    const { id, value } = e.target;
    setEmployees((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleError = (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  };

  const handleCsvFileChange = (e) => {
    const file = e.target.files[0];
    setCsvFile(file);
  };

  const handleSendNotificationChange = (e) => {
    setSendNotification(e.target.checked); // Toggle notification checkbox
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Upload Employees CSV</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <div className="loading"></div>}
        <div className="col-xl-10 mx-xl-auto">
          <div className="card card-raised mb-3">
            <div className="card-body p-4">
              <form onSubmit={handleSubmit}>
                <div className="row mb-3">
                  <div className="form-floating-sm">
                    <label htmlFor="companycode">Company Code</label>
                    <input
                      className="form-control"
                      id="companycode"
                      type="text"
                      value={companycode}
                      readOnly
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="form-floating-sm">
                    <label htmlFor="file">Upload File:</label>
                    <input
                      className="form-control"
                      id="file"
                      type="file"
                      placeholder="Upload document"
                      onChange={handleCsvFileChange}
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-auto">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="sendNotification"
                        checked={sendNotification}
                        onChange={handleSendNotificationChange}
                      />
                      <label className="form-check-label" htmlFor="sendNotification">
                        Send Notification
                      </label>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <input
                      type="submit"
                      value="SAVE"
                      className="btn btn-primary"
                      disabled={loading}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <Button variant="secondary" onClick={onRequestClose}>
                      Close
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

export default UploadEmployeesCsvFile;
